import { z } from "zod";
export const ZWeeklyAppStartsSchema = z.object({
    fromDate: z.string().optional().nullable(),
    toDate: z.string().optional(),
    projectNo: z.number().optional().nullable(),
    toggleUniqueUsers: z.enum(["YES", "NO"]),
    appName: z.string().optional().nullable(),
    issueBoardTemplate: z.string().optional().nullable(),
});
